module.exports = __webpack_public_path__ + "img/BETA.3cd396d0.svg";